var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [{ show: _vm.animation_status === 2 }, { filter: _vm.vague }],
      attrs: { id: "boxstart" },
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boxstart_main" }, [
      _c("div", { staticClass: "startCanvas", attrs: { id: "startCanvas" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }